import { getApiBaseUrl } from '../utils/apiBaseUrl';

export interface DeleteAddressAsync {
  message: string;
}

export const deleteFeedbackAdmin = async (
  id: number,
  token: string
): Promise<DeleteAddressAsync> => {
  const baseUrl = getApiBaseUrl();

  const response = await fetch(`${baseUrl}/api/Admin/DeleteAddressAsync/${id}`, {
    method: "DELETE",
  headers: {
    Authorization: `Bearer ${token}`,
    "Content-Type": "application/json",
  },
  body: JSON.stringify({ id }),
  });

  if (!response.ok) {
    throw new Error(`Failed to delete address: ${response.status}`);
  }

  const data: DeleteAddressAsync = await response.json();
  return data;
};